import { Component, OnInit } from '@angular/core';

import { IndicadorService } from '../services/indicador.service';
import { GlobalsService } from '../services/globals.service';
import { Indicadores } from '../Models/Indicadores';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-indicador-proporcion-entrega',
  templateUrl: './indicador-proporcion-entrega.component.html',
  styleUrls: ['./indicador-proporcion-entrega.component.css']
})
export class IndicadorProporcionEntregaComponent implements OnInit {

  indicador: Indicadores = new Indicadores();
  indicadores: Indicadores[] = [];

  fechaInicio: Date;
  fechaFin: Date;

  constructor(
    private globalServices: GlobalsService,
    private indicadorService:IndicadorService
  ) { }

  ngOnInit() {
 
  }


ObtenerProporcion(){

  if (isNullOrUndefined(this.fechaInicio)) {
    this.fechaInicio = new Date();
  }
  if (isNullOrUndefined(this.fechaFin)) {
    this.fechaFin = new Date();
  }

  this.indicadorService.ObtenerProporcionEntregas(this.globalServices.ObtenerCompania(),
 this.fechaInicio,this.fechaFin).subscribe(
      data=>{
        this.indicadores=data;
       
      },
      error=>{
       console.log(error);
      }


    );

}


 /**
   * Convierte la tabla asignada en un exel
   * @param tableID 
   * @param filename 
   */
  exportTableToExcel(tableID, filename = '') {
    var downloadLink;
    var dataType = 'application/vnd.ms-excel';
    var tableSelect = document.getElementById(tableID);
    var tableHTML = tableSelect.outerHTML.replace(/ /g, '%20');

    // Specify file name
    filename = filename ? filename + '.xls' : 'excel_data.xls';

    // Create download link element
    downloadLink = document.createElement("a");

    document.body.appendChild(downloadLink);

    if (navigator.msSaveOrOpenBlob) {
      var blob = new Blob(['\ufeff', tableHTML], {
        type: dataType
      });
      navigator.msSaveOrOpenBlob(blob, filename);
    } else {
      // Create a link to the file
      downloadLink.href = 'data:' + dataType + ', ' + tableHTML;

      // Setting the file name
      downloadLink.download = filename;

      //triggering the function
      downloadLink.click();
    }
  }



}
